export default "__VITE_ASSET__6c6d64b0__"